export default "__VITE_ASSET__d336d58d__"